import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';

export class PriceTypeChangedApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.PriceTypeChanged;

  constructor(private priceType: PriceTypes, private location: string) {

  }

  getPayload(): any {
    return {
      priceType: this.priceType,
      location: this.location
    };
  }
}
